//dependencies
import React from "react";

import Avatar from "../../../components/Avatar";
//components
import Button from "../../../components/Button";
import Link from "../../../components/Link";
//template
import ContentModal from "../../../components/Modal/Templates/ContentModal";
import Typography from "../../../components/Text";
import TruncatedText from "../../../components/Text/TruncatedText";

//utils
import toEmployeeUrl from "../../../utils/URLs/Employee";

//css
import css from "../AvatarGroup.module.scss";

type AvatarGroupModalProps = {
	employees: { _id: string; name: string }[];
	isOpen: boolean;
	onClose: () => void;
};

const AvatarGroupModal = ({ employees, isOpen, onClose }: AvatarGroupModalProps) => {
	return (
		<ContentModal
			title={
				<Typography size="sub-heading" weight="semi-bold">
					Goal Shared With
				</Typography>
			}
			buttons={[
				<Button key="CloseButton" onClick={onClose} color="green">
					Close
				</Button>,
			]}
			isOpen={isOpen}
			handleClose={onClose}
			size="auto"
		>
			<div className={css.employeeList}>
				{employees.map((employee, index) => (
					<div key={employee._id} className={`${css.row} ${index % 2 !== 0 ? null : css.odd}`}>
						<Typography size="paragraph-3" weight="regular">
							{index + 1}
						</Typography>
						<Avatar size={20} id={employee._id} />
						<Link href={toEmployeeUrl(employee._id)} forceHardReload={true}>
							<TruncatedText text={employee.name} maxWidth={248} size="paragraph-3" weight="regular" />
						</Link>
					</div>
				))}
			</div>
		</ContentModal>
	);
};

export default AvatarGroupModal;
